<script>
    import IconShow from '@/components/icon/IconShow.vue';

    export default {
        props: {
            tag: Object,
        },
        components: {
            IconShow: IconShow,
        },
        methods: {
            async selectTag() {
                this.$store.commit('TAG_DATA_EDIT_SET', this.tag);
                this.$store.commit('IS_SHOW_TAG_EDIT', true);
                this.$store.dispatch('CHECK_TAG_EDIT');
            }
        }
    }
</script>


<template>
    <li
        @click="selectTag"
    >
        <div
            class="blur_white cursor_pointer_label"
        >
            <label>[{{ tag['id'] }}]</label>
            <label
                class="ml_5"
            >[use: {{ tag['used_times_count'] }}]</label>
            <IconShow 
                v-if="tag['is_default']"
                class="ml_5"
                iconWidth="14px"
                iconHeight="14px"
            />
            <label
                class="ml_5"
            >{{ tag['name'] }}</label>
        </div>
    </li>
</template>


<style scoped>
    li {
        border-bottom: 2px solid var(--header-separator);
        font-size: 14px;
    }
    li > div {
        padding-top: 2px;
    }
</style>